import { h } from "preact";
import {TransitionGroup} from "preact-transitioning";
import {SlideInfoBlock} from "./SlideInfoBlock";

export type DescriptionSlidesProp = {
  slides: any;
  activeSlideId: number;
} & any

const DescriptionSlides = ({slides, activeSlideId}: DescriptionSlidesProp) => {
        return (
      <div className="slider1">
        <TransitionGroup>
          {slides.map((slide: any, i: number) => {
            const {
              description,
              id,
              image,
              image_webp,
              service_id,
              title,
              advantages
            } = slide;

            return (
              <SlideInfoBlock
                key={id}
                serviceId={service_id}
                title={title}
                description={description}
                advantages={advantages} 
                isActive={activeSlideId === i} 
              />
            )
          })}
        </TransitionGroup>
      </div>
        );
}

export { DescriptionSlides }
